import { lazy } from 'react';

import { IRoute } from '../../types/routes';

import { PendingMessagesBadge } from '@/components/PendingMessagesBadge';

const TeacherDashboardPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.DashboardPage }))
);

const TicketsPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.TicketsPage }))
);

const EventsPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.EventsPage }))
);

const EventPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.EventPage }))
);

const CoursePage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.CoursePage }))
);

const CoursesPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.CoursesPage }))
);

const QuizzesPage = lazy(() =>
  import('@/pages/Manager').then(module => ({ default: module.QuizzesPage }))
);

const QuestionBankPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.QuestionBankPage }))
);

const QuizFormPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.QuizFormPage }))
);

const TutoringGroupsPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.TutoringGroupsPage }))
);

const TutoringGroupPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.TutoringGroupPage }))
);

const ChatPage = lazy(() =>
  import('@/pages/Common').then(module => ({ default: module.ChatPage }))
);

const ExamGroupsPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.ExamGroupsPage }))
);

const StudentsPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.StudentsPage }))
);

const ProfilePage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.ProfilePage }))
);

const ExamsPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.ExamsPage }))
);

const ExamDetailPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.ExamDetailPage }))
);

const DeliverablesPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.DeliverablesPage }))
);

const LiveClassPage = lazy(() =>
  import('@/pages/Teacher').then(module => ({ default: module.LiveClassPage }))
);

export const TEACHER: IRoute[] = [
  {
    title: 'DASHBOARD',
    path: '/dashboard',
    icon: 'Home',
    Component: TeacherDashboardPage,
    showInMenu: true
  },
  {
    title: 'COURSES',
    path: '/content/courses',
    icon: 'Notebook',
    Component: CoursesPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'COURSES',
        path: ':_id',
        icon: 'Undefined',
        Component: CoursePage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'DOUBTS',
    path: '/communication/tickets',
    icon: 'MailAll',
    Component: TicketsPage,
    showInMenu: true
  },
  {
    title: 'EXAMS',
    path: '/content/exams',
    icon: 'DocumentRequirements',
    Component: ExamsPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'EXAMS',
        path: ':_id',
        icon: 'Undefined',
        Component: ExamDetailPage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'TESTS',
    path: '/content/tests',
    icon: 'TestTool',
    Component: QuizzesPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'TESTS',
        path: ':_id/edit',
        icon: 'Undefined',
        Component: QuizFormPage,
        showInMenu: false
      },
      {
        title: 'CREATE_TEST',
        path: 'create',
        icon: 'Undefined',
        Component: QuizFormPage,
        showInMenu: false
      },
      {
        title: 'TESTS',
        path: 'import',
        icon: 'Undefined',
        Component: QuizFormPage,
        showInMenu: false
      },
      {
        title: 'QUESTION_BANK',
        path: 'question-bank',
        icon: 'Undefined',
        Component: QuestionBankPage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'DELIVERABLES',
    path: '/content/deliverables',
    icon: 'DocumentExport',
    Component: DeliverablesPage,
    showInMenu: true
  },
  {
    title: 'STUDENTS',
    path: '/students',
    icon: 'UserData',
    Component: StudentsPage,
    showInMenu: true
  },
  {
    title: 'LIVE_EVENTS',
    path: '/content/calendar',
    icon: 'EventSchedule',
    Component: EventsPage,
    showInMenu: true,
    subroutes: [
      {
        title: 'LIVE_EVENTS',
        path: ':_id',
        icon: 'Undefined',
        Component: EventPage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'TUTORING_GROUPS',
    path: '/communication/tutoring-groups',
    icon: 'UserMultiple',
    Component: TutoringGroupsPage,
    showInMenu: true,
    TitleAddon: PendingMessagesBadge,
    subroutes: [
      {
        title: 'TUTORING_GROUPS',
        path: ':tutoringGroupId',
        icon: 'Undefined',
        Component: TutoringGroupPage,
        showInMenu: false
      },
      {
        title: 'TUTORING_GROUPS',
        path: ':tutoringGroupId/chat/:tutorId/:studentId',
        icon: 'Undefined',
        Component: ChatPage,
        showInMenu: false
      }
    ]
  },
  {
    title: 'EXAM_GROUPS',
    path: '/exam-groups',
    icon: 'DocumentSentiment',
    Component: ExamGroupsPage,
    showInMenu: true
  },
  {
    title: 'PROFILE',
    path: '/profile',
    icon: 'Undefined',
    Component: ProfilePage,
    showInMenu: false
  },
  {
    title: 'LIVE_CLASS',
    path: '/live-class/:meetingId',
    icon: 'Undefined',
    Component: LiveClassPage,
    showInMenu: false
  }
];
